"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isLoading;

var _resift = require("resift");

function getLoading(status) {
  if (typeof status === 'number') return (status & _resift.LOADING) !== 0;
  return status.isLoading();
}

function isLoading() {
  for (var _len = arguments.length, statuses = new Array(_len), _key = 0; _key < _len; _key++) {
    statuses[_key] = arguments[_key];
  }

  return statuses.some(getLoading);
}